import React from 'react';
export function Footer() {
  return <footer className="w-full px-6 md:px-12 py-12 border-t border-stone-border mt-[0px]" data-id="element-23" data-mp="32wd0e9mw79qd">
      <div className="max-w-7xl mx-auto flex justify-center items-center" data-id="element-24" data-mp="3gg0za3iktxxn">
        <div className="text-sm text-[#767676] font-[400]" data-id="element-25" data-mp="32onj8zjvni7d">
          © {new Date().getFullYear()} Shihwen Wang. All rights reserved.
        </div>
      </div>
    </footer>;
}